import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["backgroundColor", "backgroundImage", "gradientAngle", "innerRef", "startGradientColor", "endGradientColor"];
import styled from 'styled-components';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import globalNavHeight from 'nav-meta/global-nav-height';
// @ts-expect-error svgs are untyped modules
import blobsImageUrl from 'bender-url!marketplace-ui-common/img/storefront-header-blobs.svg';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledHeaderWrapper = styled(props => {
  const {
      innerRef
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("header", Object.assign({
    ref: innerRef
  }, rest));
}).withConfig({
  displayName: "StyledHeaderWrapper",
  componentId: "r3x72a-0"
})(["padding:0 16px;width:100%;background-color:", ";background-image:", ",linear-gradient( ", ",", ",", " );background-position:center center;background-repeat:no-repeat;background-size:auto 100%;border-top:", ";@media screen and (max-width:", "){background-image:linear-gradient( ", ",", ",", " );}&.sticky{padding:0 0 ", ";}"], props => props.backgroundColor, props => props.backgroundImage === 'none' ? 'none' : `url(${blobsImageUrl})`, props => props.gradientAngle || '-303deg', props => props.startGradientColor, props => props.endGradientColor, props => props.divider ? `1px solid ${GREAT_WHITE}` : 'none', GRID_BREAKPOINT_SMALL, props => props.gradientAngle || '-303deg', props => props.startGradientColor, props => props.endGradientColor, globalNavHeight);
export default StyledHeaderWrapper;